import React, { Suspense, lazy, useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import './App.scss'
import axios from 'axios'

const Agora = lazy(() => import('../pages/Agora'))
const Aws = lazy(() => import('../pages/Aws'))
const Rte = lazy(() => import('../pages/Rte'))
const RteHackathon2021 = lazy(() => import('../pages/Rte-hackathon-2021'))
const Deveco2021 = lazy(() => import('../pages/Deveco2021'))

// const TxLight = lazy(() => import('../pages/TxLight'))
const AwsInnovate = lazy(() => import('../pages/AwsInnovate'))
const AwsInnovate2 = lazy(() => import('../pages/AwsInnovate2'))

const TxLight2022 = lazy(() => import('../pages/TxLight2022'))

const OpenInra2021 = lazy(() => import('../pages/Openinfra'))
const OIGuide = lazy(() => import('../pages/Openinfra/Guide'))
const Agenda = lazy(() => import('../pages/Openinfra/Agenda'))
const Sponsorship = lazy(() => import('../pages/Openinfra/Sponsorship'))
const XinChuang = lazy(() => import('../pages/XinChuang'))
const Horizon = lazy(() => import('../pages/Horizon2021'))
const DevGuide = lazy(() => import('../pages/XinChuang/DevGuide'))
const SponsorTopic = lazy(() => import('../pages/Openinfra/Topic'))
const MuLan = lazy(() => import('../pages/MuLan-2021'))
const Universal = lazy(() => import('../pages/Universal'))
const Keynotes = lazy(() => import('../pages/Keynotes'))
const CDC2021 = lazy(() => import('../pages/CDC2021'))
const TestCDC2021 = lazy(() => import('../pages/TestCDC2021'))
const ShePower = lazy(() => import('../pages/ShePower'))
const TenYears = lazy(() => import('../pages/TenYears'))

const OpenInra2022 = lazy(() => import('../pages/OpenInfra2022'))
const Sponsorship2022 = lazy(() => import('../pages/OpenInfra2022/Sponsorship'))
const Issu2022 = lazy(() => import('../pages/OpenInfra2022/Issu'))
const Agenda2022 = lazy(() => import('../pages/OpenInfra2022/Agenda'))

const KeynotesOld = lazy(() => import('../pages/KeynoteOld'))

const Test = lazy(() => import('../pages/Openinfra/Presentation'))
const Hackathon2022 = lazy(() => import('../pages/Hackathon2022'))
const Hackathon2023 = lazy(() => import('../pages/Hackathon2023'))

const Mulan2022 = lazy(() => import('../pages/Mulan2022'))

function App() {
  function Home() {
    useEffect(() => {
      window.location.href = 'https://segmentfault.com/'
    }, [])
    return <br />
  }
  useEffect(() => {
    axios.get('https://gateway.segmentfault.com/wechat/sdk').then((result) => {
      const res = result.data
      if (res instanceof Object) {
        if (window.wx) {
          window.wx.config(res)
          window.wx.error(function (err) {
            console.error('config error', err)
          })
          window.shareMedthods = res.jsApiList.slice()
        }
      }
    })
  }, [])

  return (
    <div className="App">
      <Router basename="/">
        <Suspense fallback={<div style={{ backgroundColor: '#fff' }} />}>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/:site(bdtc-2021)/:tabName?" exact component={Universal} />
            <Route path="/ten-years">
              <TenYears />
            </Route>
            <Route path="/rtc-hackathon-2020">
              <Agora />
            </Route>
            <Route path="/aws-hackathon-2020">
              <Aws />
            </Route>
            <Route path="/aws-2022">
              <AwsInnovate />
            </Route>
            <Route path="/aws-aiml-2022">
              <AwsInnovate2 />
            </Route>
            <Route path="/rte-hackathon-2020">
              <Rte />
            </Route>
            <Route path="/tx-light">
              <TxLight2022 />
            </Route>

            <Route path="/rte-hackathon-2021">
              <RteHackathon2021 />
            </Route>
            <Route path="/dev-eco-2021">
              <Deveco2021 />
            </Route>
            <Route path="/openinfra-2021" exact>
              <OpenInra2021 />
            </Route>

            <Route path="/openinfra-2021/test" exact>
              <Test />
            </Route>
            <Route path="/openinfra-2021/guide" exact>
              <OIGuide />
            </Route>
            <Route path="/openinfra-2021/agenda" exact>
              <Agenda />
            </Route>
            <Route path="/openinfra-2021/sponsorship" exact>
              <Sponsorship />
            </Route>
            <Route path="/openinfra-2021/topic" exact>
              <SponsorTopic />
            </Route>
            <Route path="/openinfra-2022" exact>
              <OpenInra2022 />
            </Route>
            <Route path="/openinfra-2022/agenda" exact>
              <Agenda2022 />
            </Route>
            <Route path="/openinfra-2022/issu" exact>
              <Issu2022 />
            </Route>
            <Route path="/openinfra-2022/sponsorship" exact>
              <Sponsorship2022 />
            </Route>
            <Route path="/xinchuang" exact>
              <XinChuang />
            </Route>
            <Route path="/horizonai-2021" exact>
              <Horizon />
            </Route>
            <Route exact path="/docs">
              <DevGuide />
            </Route>
            <Route path="/mulan-2021" exact>
              <MuLan />
            </Route>
            <Route path="/openinfra" exact>
              <Keynotes />
            </Route>

            <Route path="/openinfra/2021" exact>
              <KeynotesOld />
            </Route>
            <Route path="/cds-2022/:type(videos)?" exact component={CDC2021} />
            <Route path="/testcds-2022/:type(videos)?" exact component={TestCDC2021} />
            <Route path="/shepower" exact component={ShePower} />

            <Route path="/hackathon-2022" exact component={Hackathon2022} />

            <Route path="/mulan-2022" exact component={Mulan2022} />
            <Route path="/sf-hackathon-2023/:lang(en|zh)?" exact component={Hackathon2023} />
          </Switch>
        </Suspense>
      </Router>
    </div>
  )
}

export default App
